import { ChangeDetectionStrategy, Component, input } from '@angular/core';

// See ../banner-wrapper/CLAUDE.md and user-home/CLAUDE.md for the swiper recipe.
// Encapsulates the home-swiper container: the my-medium gap (auto-collapsed to 0
// when the swiper renders no slides), and the external in-flow pagination div.
// Project the whole <swiper> so Swiper's own slide detection is untouched.
@Component({
  selector: 'app-swiper-wrapper',
  template: '<ng-content></ng-content><div [id]="paginationId()" class="swiper-pagination home-swiper-pagination"></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tw-block tw-relative tw-my-medium home-swiper',
  },
})
export class SwiperWrapperComponent {
  // Unique id for this swiper's pagination element; the swiper config must use
  // `pagination: { el: '#<paginationId>' }`.
  paginationId = input.required<string>();
}
